module.exports = __webpack_public_path__ + "img/error-v1.c33f562.png";